import { Action } from "redux";
import api from "../../api";
import { ShowSearchResult } from "../../typings/typings";
import { AppThunk } from "..";

export const UPDATE_SHOWS = "UPDATE_SHOWS";

interface UpdateShowsAction extends Action
{
    type: typeof UPDATE_SHOWS;
    shows: ShowSearchResult[];
}

const updateShowsAction = (shows: ShowSearchResult[]) =>
{
    const action: UpdateShowsAction = {
        type: UPDATE_SHOWS,
        shows: shows
    };
    return action;
};

export const thunkUpdateShows = (): AppThunk => async (dispatch) =>
{
    const response = await api.umbracoClient.getShows();

    const mapped = response.map((show) =>
    {
        if (show.events)
        {
            show.events = show?.events.map((event) =>
            {
                event.startDate = event.startDate ? new Date(event.startDate) : undefined;
                event.endDate = event.endDate ? new Date(event.endDate) : undefined;

                if (event.showTimes)
                {
                    event.showTimes = event.showTimes.map((showTime) =>
                    {
                        showTime.date = new Date(showTime.date);
                        return showTime;
                    });

                    // Sort dates asc
                    event.showTimes = event.showTimes.sort((left, right) =>
                    {
                        return left.date.getTime() - right.date.getTime();
                    });
                }

                return event;
            }).sort((left, right) =>
            {
                if (left.startDate && right.startDate)
                {
                    return left.startDate?.getTime() - right.startDate?.getTime();
                }
                return -1;
            });
        }

        return show;
    });

    dispatch(updateShowsAction(mapped));
};

export const RESET_FILTERS = "RESET_FILTERS";

interface ResetFiltersAction extends Action
{
    type: typeof RESET_FILTERS;
}

const resetFiltersAction = (): ResetFiltersAction =>
{
    return {
        type: RESET_FILTERS
    };
};

export const thunkResetFilters = (): AppThunk => async (dispatch) =>
{
    dispatch(resetFiltersAction());
};

export const UPDATE_FILTERS = "UPDATE_FILTERS";

export interface ShowFilters
{
    categories: string[];
    shows: string[];
    startDate?: Date;
    endDate?: Date;
}

interface UpdateFiltersAction extends Action
{
    type: typeof UPDATE_FILTERS;
    filters: ShowFilters;
}

const updateFiltersAction = (filters: ShowFilters): UpdateFiltersAction =>
{
    return {
        type: UPDATE_FILTERS,
        filters: filters
    };
};

export const thunkUpdateFilters = (filters: ShowFilters): AppThunk => async (dispatch) =>
{
    dispatch(updateFiltersAction(filters));
};

export type RouteActions =
    UpdateShowsAction |
    ResetFiltersAction |
    UpdateFiltersAction;